export * from './app.component';
export * from './albums/index';
export * from './api/index';
export * from './artists/index';
export * from './dashboard/index';
export * from './four04/index';
export * from './home/index';
export * from './my-discoveries/index';
export * from './playlists/index';
export * from './search/index';
export * from './shared/index';
export * from './songs/index';
export * from './user/index';
export * from './my-music-library/index';
export * from './recent-licenses/recent-licenses.component';
export * from './player/index';
export * from './advanced-search/advanced-search.component';
export * from './cms';
export * from './my-avatar/my-avatar.component';
export * from './search-page/search-page.component';
export * from './paypal-errors.component';
export * from './invite-friends';
export * from './cart';
export * from './my-reports/my-reports.component';


// WEBPACK FOOTER //
// ./src/app/index.ts